export default "__VITE_ASSET__BotNJK5p__"